import React from "react";

function toCssSize(value) {
  if (value == null) return undefined;
  return typeof value === "number" ? `${value}px` : value;
}

export default function Skeleton({
  width,
  height = "1rem",
  radius = 6,
  className = "",
  style,
  ...props
}) {
  return (
    <span
      className={`agent-skeleton ${className}`.trim()}
      style={{
        width: width == null ? "100%" : toCssSize(width),
        height: toCssSize(height),
        borderRadius: toCssSize(radius),
        ...style,
      }}
      aria-hidden="true"
      {...props}
    />
  );
}
